export class SaveSchoolAttendanceMonitorRequest {
    closingServiceId: number;
    schoolId: number;
    year: number;
    month: number;
    day: number;
    serviceId: number;
    exerciseId: number;
    serviceConceptDays: ServiceConceptDayRequest[];
}

export class ServiceConceptDayRequest {
    serviceConceptId: number;
    amount: number;
}